export enum MemberStatusTypeEnum {
  Active = 1,
  Inactive = 2,
  Pending = 3
}
